export interface GtmConsentState {
	necessary: boolean;
	preferences: boolean;
	analytics: boolean;
	marketing: boolean;
}

export const GTM_CONSENT_STORAGE_KEY = "ms-cookie-consent";

export function consentStateToGtag(state: GtmConsentState): Record<string, "granted" | "denied"> {
	return {
		ad_storage: state.marketing ? "granted" : "denied",
		analytics_storage: state.analytics ? "granted" : "denied",
		ad_user_data: state.marketing ? "granted" : "denied",
		ad_personalization: state.marketing ? "granted" : "denied",
		security_storage: "granted",
		functionality_storage: state.preferences ? "granted" : "denied",
		personalization_storage: state.preferences ? "granted" : "denied",
	};
}

export function getGtmConsentScriptContent(): string {
	const key = JSON.stringify(GTM_CONSENT_STORAGE_KEY);
	return [
		"window.dataLayer = window.dataLayer || [];",
		"function gtag(){ dataLayer.push(arguments); }",
		"window.gtag = gtag;",
		"gtag('consent', 'default', {",
		"  'ad_storage': 'denied',",
		"  'analytics_storage': 'denied',",
		"  'ad_user_data': 'denied',",
		"  'ad_personalization': 'denied',",
		"  'security_storage': 'granted',",
		"  'functionality_storage': 'denied',",
		"  'personalization_storage': 'denied'",
		"});",
		"(function(){",
		"  try {",
		"    var raw = localStorage.getItem(" + key + ");",
		"    if (!raw) return;",
		"    var o = JSON.parse(raw);",
		"    if (!o || typeof o.necessary !== 'boolean') return;",
		"    gtag('consent', 'update', {",
		"      'ad_storage': o.marketing ? 'granted' : 'denied',",
		"      'analytics_storage': o.analytics ? 'granted' : 'denied',",
		"      'ad_user_data': o.marketing ? 'granted' : 'denied',",
		"      'ad_personalization': o.marketing ? 'granted' : 'denied',",
		"      'functionality_storage': o.preferences ? 'granted' : 'denied',",
		"      'personalization_storage': o.preferences ? 'granted' : 'denied'",
		"    });",
		"  } catch(e) {}",
		"})();",
	].join("\n");
}

export function pushConsentUpdate(state: GtmConsentState): void {
	if (typeof window === "undefined" || typeof (window as unknown as { gtag?: unknown }).gtag !== "function") {
		return;
	}
	(window as unknown as { gtag: (a: string, b: string, c: Record<string, string>) => void }).gtag("consent", "update", consentStateToGtag(state));
}
